<div class="section">
  <header>
    <h1>403 - Forbidden</h1>
  </header>

  <main>
    <h3 class="error-message">
      You do not have permission to access this page.
    </h3>
    <button routerLink="/dashboard">Dashboard</button>
  </main>
</div>
